import { initialTableShow } from 'utils/settings';

export const mainTableConf = [
  {
    isSortable: true,
    field: 'companyName',
    title: 'Company Name',
    show: true,
    width: 417,
    valuesExport: [
      'companyName',
      'customerId',
      'status',
      'companySize',
      'country',
      'poc',
      'partnerType',
      'customerType'
    ]
  },
  {
    isSortable: true,
    field: 'terminationStatusDate',
    title: 'Status Date',
    show: false,
    width: 222,
    valuesExport: ['terminationStatusDate']
  },
  {
    isSortable: true,
    field: 'healthPoint',
    title: 'Health Score',
    show: true,
    width: 172,
    fromToGroup: true,
    valuesExport: ['healthPoint', 'healthStatus']
  },
  {
    isSortable: false,
    field: 'tmUtilized',
    title: 'TM',
    fromToGroup: true,
    show: true,
    width: 104,
    valuesExport: ['tmUtilized', 'tmLicenses']
  },
  {
    isSortable: false,
    field: 'psUtilized',
    title: 'PS',
    fromToGroup: true,
    show: true,
    width: 80,
    valuesExport: ['psUtilized', 'psLicenses']
  },
  {
    isSortable: false,
    field: 'appsUtilized',
    title: 'Apps',
    fromToGroup: true,
    show: true,
    width: 96,
    valuesExport: ['appsUtilized', 'appsLicenses']
  },
  {
    isSortable: true,
    field: 'plan',
    title: 'Pricing Plan',
    show: true,
    width: 140,
    valuesExport: ['plan']
  },
  {
    isSortable: true,
    field: 'billingCycle',
    title: 'Billing Cycle',
    show: true,
    width: 144,
    valuesExport: ['billingCycle']
  },
  {
    isSortable: true,
    field: 'arr',
    title: 'ARR',
    fromToGroup: true,
    show: true,
    width: 96,
    valuesExport: ['arr']
  },
  {
    isSortable: true,
    field: 'mau',
    title: 'MAU',
    fromToGroup: true,
    show: true,
    width: 96,
    valuesExport: ['mau']
  },
  {
    isSortable: true,
    field: 'npsScore',
    title: 'NPS',
    fromToGroup: true,
    show: true,
    width: 96,
    valuesExport: ['npsScore']
  },
  {
    isSortable: true,
    field: 'openTickets',
    title: 'Open Tickets',
    fromToGroup: true,
    show: true,
    width: 168,
    valuesExport: ['openTickets']
  },
  {
    isSortable: true,
    field: 'csatChatScore',
    title: 'CSAT Chat Score',
    fromToGroup: true,
    show: true,
    width: 198,
    valuesExport: ['csatChatScore']
  },
  {
    isSortable: true,
    field: 'csatTicketScore',
    title: 'CSAT Tickets Score',
    fromToGroup: true,
    show: true,
    width: 222,
    valuesExport: ['csatTicketScore']
  },
  {
    isSortable: true,
    field: 'firstPaymentDate',
    title: 'First Payment',
    show: true,
    width: 156,
    valuesExport: ['firstPaymentDate']
  },
  {
    isSortable: true,
    field: 'firstInvoiceAt',
    title: 'First Invoice',
    show: true,
    width: 156,
    valuesExport: ['firstInvoiceAt']
  },
  {
    isSortable: true,
    field: 'nextBillingDate',
    title: 'Next Billing',
    show: true,
    width: 136,
    valuesExport: ['nextBillingDate']
  },
  {
    isSortable: false,
    field: 'industry',
    title: 'Industry',
    show: true,
    width: 200,
    valuesExport: ['industry']
  },
  {
    isSortable: false,
    field: 'source',
    title: 'Origin',
    show: true,
    width: 168,
    valuesExport: ['source']
  },
  {
    isSortable: true,
    field: 'accountManager',
    title: 'Acc. Manager',
    show: true,
    width: 156,
    valuesExport: ['accountManager']
  },
  {
    isSortable: true,
    field: 'customerSuccessEngineer',
    title: 'CS Engineer',
    show: true,
    width: 144,
    valuesExport: ['customerSuccessEngineer']
  },
  {
    isSortable: true,
    field: 'ageInMonths',
    title: 'Age In Months',
    show: true,
    width: 144,
    valuesExport: ['ageInMonths']
  },
  {
    isSortable: true,
    field: 'region',
    title: 'Region',
    show: true,
    width: 88,
    valuesExport: ['region']
  },
  {
    isSortable: true,
    field: 'coupons.name',
    title: 'Coupons Name',
    show: true,
    width: 200,
    valuesExport: ['coupons']
  },
  {
    isSortable: true,
    field: 'coupons.type',
    title: 'Coupons Type',
    show: true,
    width: 200,
    valuesExport: ['coupons']
  },
  {
    isSortable: true,
    field: 'coupons.duration',
    title: 'Coupons Duration',
    show: true,
    width: 176,
    valuesExport: ['coupons']
  },
  {
    isSortable: true,
    field: 'paymentType',
    title: 'Payment Method',
    show: true,
    width: 200,
    valuesExport: ['paymentType']
  },
  {
    isSortable: true,
    field: 'qbr.sentiment',
    title: 'Sentiment',
    show: true,
    width: 132,
    valuesExport: ['qbr']
  },
  {
    isSortable: true,
    field: 'qbr.occurredDate',
    title: 'Last QBR Date',
    show: true,
    width: 168,
    valuesExport: ['qbr']
  }
];

export const exportConfig = {
  exportUrl: '/customers/export',
  exportName: 'All-customers_',
  exportFormat: 'zip'
};

export const defaultFilters = {
  companyName: '',
  firstPaymentDate: { startDate: null, endDate: null },
  firstInvoiceAt: { startDate: null, endDate: null },
  nextBillingDate: { startDate: null, endDate: null },
  plan: [],
  billingCycle: [],
  status: ['Active', 'Non Renewing'],
  companySize: [],
  country: [],
  industry: [],
  partnerType: [],
  poc: [],
  region: [],
  customerSuccessEngineer: [],
  accountManager: [],
  healthStatus: [],
  'coupons.name': [],
  'coupons.type': [],
  'coupons.duration': [],
  'qbr.occurredDate': { startDate: null, endDate: null },
  'qbr.sentiment': [],
  'qbr.isExist': '',
  paymentType: [],
  isTestTenant: 'False',
  terminationStatus: []
};

export const defaultNavigation = {
  fieldName: 'firstPaymentDate',
  direction: initialTableShow.direction,
  currentPage: initialTableShow.currentPage,
  itemsPerPage: initialTableShow.itemsPerPage,
  arr: {
    from: '',
    to: ''
  },
  mau: {
    from: '',
    to: ''
  },
  tmUtilized: {
    from: '',
    to: ''
  },
  psUtilized: {
    from: '',
    to: ''
  },
  appsUtilized: {
    from: '',
    to: ''
  },
  healthPoint: {
    from: '',
    to: ''
  },
  npsScore: {
    from: '',
    to: ''
  },
  openTickets: {
    from: '',
    to: ''
  },
  csatChatScore: {
    from: '',
    to: ''
  },
  csatTicketScore: {
    from: '',
    to: ''
  }
};

// Mapping between filters and their dependent columns
// When a filter has non-default values, its dependent column auto-shows
export const FILTER_COLUMN_DEPENDENCIES = {
  terminationStatus: {
    columnField: 'terminationStatusDate',
    showWhenFilterHasValue: true
  }
  // Add more filter-column dependencies here as needed
  // Example: healthStatus: { columnField: 'healthStatusDate', showWhenFilterHasValue: true }
};
